<template>
	<label
		class="relative bg-neutral-50 block rounded-full"
		:class="classBox"
	>
		<input
			v-model="proxyChecked"
			type="radio"
			:disabled="disabled"
			:value="value"
			class="absolute top-0 right-0 h-full w-full opacity-0 hidden"
		/>
		<span
			class="absolute w-4 h-4 rounded-full flex items-center justify-center opacity-0"
			:class="[positionCheck, colorRadio]"
		>
			<span
				v-if="isChecked"
				class="bg-primary-500 w-2.5 h-2.5 rounded-full"
			/>
		</span>

		<slot />
	</label>
</template>

<script setup>
const props = defineProps({
	modelValue: {
		type: [Object, Array, Number, String, Boolean],
		default: null,
	},
	value: {
		type: [Object, Array, Number, String, Boolean],
		default: null,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	positionCheck: {
		type: String,
		default: 'top-1 right-1',
	},
})

// Define emits for update:modelValue and change
const emit = defineEmits(['update:modelValue', 'change'])

// Computed property for proxyChecked
const proxyChecked = computed({
	get() {
		return props.modelValue
	},
	set(val) {
		emit('change', val)
		emit('update:modelValue', val)
	},
})

// Computed property to check if the input is checked
const isChecked = computed(() => {
	if (!props.modelValue) return false
	return props.modelValue === props.value
})

// Computed class for the box styling
const classBox = computed(() => {
	return {
		'bg-neutral-50': isChecked.value,
		'opacity-100 hover:bg-neutral-50 hover:opacity-3': !isChecked.value && !props.disabled,
		'opacity-60 bg-gray-100 cursor-default filter grayscale': props.disabled,
	}
})

// Computed colors for radio buttons
const colorRadio = computed(() => (isChecked.value ? 'border-primary-500' : 'border-neutral-300'))
</script>
